import { TableCell, TableFooter, TableRow } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { status_ru_extra, filterStatus } from '../../../helpers/passport';
import { dateRenderer, floatRenderer } from '../../../services/formatSvc';
import StatusBadge from '../../project/PassportRead/StatusBadge';
import FilterMultiSelect from '../../table/FilterMultiSelect';

export const getColumns = ({ sectionLinkPart, headFilterLookup, stratId }) => [
  {
    title: 'Портфель',
    field: 'name',
    cellStyle: { minWidth: '400px' },
    render: (rowData) => <NavLink to={`/${sectionLinkPart}/${stratId}/portfolios/${rowData.id}`}>{rowData.name}</NavLink>,
  },
  {
    title: 'Руководитель',
    field: 'head',
    cellStyle: { minWidth: '200px' },
    render: (rowData) => (rowData.head ? rowData.head.displayName : ''),
    lookup: headFilterLookup,
    customFilterAndSearch: (term, rowData) => term.length === 0 || (rowData.head && term.indexOf(rowData.head.displayName) >= 0),
    filterComponent: FilterMultiSelect,
  },
  {
    title: 'Бюджет из средств гранта (план), руб.',
    field: 'fbBudget',
    cellStyle: { minWidth: '200px' },
    render: (rowData) => floatRenderer(rowData.fbBudget),
  },
  {
    title: 'Бюджет из средств софинансирования (план), руб.',
    field: 'sfBudget',
    cellStyle: { minWidth: '220px' },
    render: (rowData) => floatRenderer(rowData.sfBudget),
  },
  {
    title: 'Введено по проектам из средств гранта (план), руб.',
    field: 'fbProjBudget',
    cellStyle: { minWidth: '220px' },
    render: (rowData) => floatRenderer(rowData.fbProjBudget),
  },
  {
    title: 'Введено по проектам из средств СФ (план), руб.',
    field: 'sfProjBudget',
    cellStyle: { minWidth: '220px' },
    render: (rowData) => floatRenderer(rowData.sfProjBudget),
  },
  {
    title: 'Количество проектов, входящих в портфель',
    field: 'projsCount',
    // cellStyle: {minWidth: '220px'},
  },
  {
    title: 'Статус',
    field: 'status',
    lookup: status_ru_extra,
    render: (rowData) => <StatusBadge width={140} status={rowData.status} />,
    filterComponent: FilterMultiSelect,
    customFilterAndSearch: (term, rowData) => {
      if (term.length === 0) return true;
      return term.includes(rowData.status);
    },
  },
];

const footerCellStyle = { fontWeight: 'bold', color: 'inherit', fontSize: 'inherit' };

export const getFooter = ({ renderData }) => {
  const getSumCell = (fieldName, isRenderFloat) => {
    let value = _.sumBy(renderData, fieldName);
    if (isRenderFloat) value = floatRenderer(value);

    return (
      <TableCell key={fieldName} style={footerCellStyle}>
        {value}
      </TableCell>
    );
  };

  return (
    <TableFooter>
      <TableRow>
        <TableCell />
        <TableCell style={footerCellStyle} colSpan="2">
          ИТОГО
        </TableCell>
        {getSumCell('fbBudget', true)}
        {getSumCell('sfBudget', true)}
        {getSumCell('fbProjBudget', true)}
        {getSumCell('sfProjBudget', true)}
        {getSumCell('projsCount')}
        <TableCell />
      </TableRow>
    </TableFooter>
  );
};
